export const accordionSummaryStyles = {
  '& .MuiAccordionSummary-content': {
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    flexGrow: 0,
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    marginLeft: 1,
    marginRight: 'auto',
  },
};
